module.exports = __webpack_public_path__ + "img/UA.f8dff900.svg";